import { DeleteDialogService } from 'services/delete-dialog-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { MarkingColorService } from 'services/marking-color-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class MarkingColorDetail {
  private markingColor: Models.MarkingColor;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private markingColorService: MarkingColorService,
    private deleteDialogService: DeleteDialogService
  ) {}

  private activate(params) {
    this.markingColorService
      .get(params.Id)
      .then( (res) => {
        this.markingColor = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private updateMarkingColor() {
    this.markingColorService
      .put(this.markingColor, this.markingColor.Id)
      .then((res) => {
        this.eventAggregator.publish('markingColorListReset', 1);
        this.toastService.showSuccess('markingColor.updated');
        this.router.navigateToRoute('marking-color-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private deleteMarkingColor() {
    this.deleteDialogService.confirmBeforeDelete(
      () => {
        this.markingColorService
          .delete(this.markingColor.Id)
          .then((res) => {
            this.eventAggregator.publish('markingColorListReset', 1);
            this.toastService.showSuccess('markingColor.deleted');
            this.router.navigateToRoute('marking-color-list');
          })
          .catch((err) => this.errorService.handleError(err));
        }
      ); 
  }

  private gotoParentView() {
    this.eventAggregator.publish('markingColorListReset', 1);
    this.router.navigateToRoute('marking-color-list');
  }
}
